/**
 * Vuex module for CurrentUser
 */
import debug from 'debug'
import API from '@/api'
import CurrentUser from 'Store/class/current_user'
import events from 'Store/events'

const dbg = debug('store:action:parking:')

const actions = {
  getCurrentUser ({ commit, state, dispatch }) {
    dbg('get current user')
    return API.getCurrentUser()
      .then(response => {
        commit('SET_CURRENT_USER', response.data)
        return dispatch('settingsCurrentUser', response.data, { root: true })
      })
      .catch(err => {
        dbg(err)
        const msg = API.getException(err) || 'Failed to get current user'
        events.pubError(msg)
      })
  },

  refreshPictureProfile ({ commit }) {
    if (state.currentUser?.pictureProfileUrl) {
      const pictureProfileUrl = new URL(state.currentUser.pictureProfileUrl)
      pictureProfileUrl.searchParams.set('rand', Date.now())
      commit('REFRESH_PIC', pictureProfileUrl)
    }
  }
}

const mutations = {
  SET_CURRENT_USER (state, data) {
    state.currentUser = new CurrentUser(data)
  },

  REFRESH_PIC (state, pictureProfileUrl) {
    state.currentUser.pictureProfileUrl = pictureProfileUrl.href
  }
}

const state = {
  currentUser: null
}

const getters = {
  currentUser: state => state.currentUser
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
